export const LOAD_PROFILE = "LOAD_PROFILE";
export const FOLLOW = "FOLLOW";
export const UNFOLLOW = "UNFOLLOW";
export const EDIT_PROFILE_SUBMIT = "EDIT_PROFILE_SUBMIT";
export const EDIT_PROFILE_SUCCESS = "EDIT_PROFILE_SUCCESS";
export const LOAD_JOURNAL = "LOAD_JOURNAL";
export const REFRESH_AVATAR = "REFRESH_AVATAR";
export const LOAD_FAVORITES = "LOAD_FAVORITES";
export const LOAD_RATINGS = "LOAD_RATINGS";
export const LOAD_ACTIVITY = "LOAD_ACTIVITY";
